"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getCurrentTransform = _interopRequireDefault(require("./getCurrentTransform"));

var _getNearestKeyFrames2 = _interopRequireDefault(require("./getNearestKeyFrames"));

var getElementTransformAtFrame = function getElementTransformAtFrame(element, frame) {
  var useCurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var transforms = element.transforms;
  var animationKeyFrames = Object.keys(transforms).map(function (frameNum) {
    return parseInt(frameNum, 10);
  }); // If user is currently dragging, use the temporary transform set on element
  // If we've elected to only use the current transform then ignore temporary one

  if (!useCurrent && element.isEditingTransform) {
    return element.editedTransform;
  } // Calculate the current transform based on the frame


  var _getNearestKeyFrames = (0, _getNearestKeyFrames2["default"])(animationKeyFrames, frame),
      leftKeyFrame = _getNearestKeyFrames.leftKeyFrame,
      rightKeyFrame = _getNearestKeyFrames.rightKeyFrame;

  return (0, _getCurrentTransform["default"])(transforms, leftKeyFrame, rightKeyFrame, frame);
};

var _default = getElementTransformAtFrame;
exports["default"] = _default;